import "./app.css";
import App from "./App.svelte";
import { mount } from "svelte";
import { connection } from "./lib/connection.svelte.ts";

connection.tryAutoReconnect();

const app = mount(App, { target: document.getElementById("app")! });
export default app;
